import useSWR from 'swr';
import { useMemo } from 'react';

import { httpGet, httpPost } from 'src/utils/cms-axios';

export async function getPostSummaryAdminConfig(site_id, post_type_id) {
    const res = await httpGet("/post-summary-admin-config", {
        "post_type_id": post_type_id,
    }, { "cms-site-id": site_id }, "/config-api");
    return res;
}

export function updatePostSummaryAdminConfig(data) {
    const { site_id, post_type_id, settings } = data;
    return httpPost(`/post-summary-admin-config?post_type_id=${post_type_id}`, {
        settings
    }, {
        "cms-site-id": site_id,
    }, "/config-api");
}

export function useGetPostSummaryAdminConfig(site_id, post_type_id) {
    const { data, isLoading, isError, isValidating, mutate, error } = useSWR(
        site_id && post_type_id ? ['/config-api/post-summary-admin-config', site_id, post_type_id] : null,
        () => getPostSummaryAdminConfig(site_id, post_type_id)
    );

    const memoizedValue = useMemo(
        () => ({
            configData: data || null,
            configLoading: isLoading,
            configError: error,
            configValidating: isValidating,
            configRefresh: mutate,
        }),
        [data, error, isLoading, isValidating, mutate]
    );

    return memoizedValue;
}
